// extracted by mini-css-extract-plugin
export default {"companyInfoContainer":"previewCompanyInfo_companyInfoContainer__caNc3","basicInfo":"previewCompanyInfo_basicInfo__URXQh","tagStatus":"previewCompanyInfo_tagStatus__JDZg0"};